<template>
  <section>
    <div ref="pbiContainer" class="pbi-container">
      <span v-if="isLoading">Fetching token...</span>
    </div>
  </section>
</template>
<script>
import * as pbi from 'powerbi-client'
import Powerbi from '@/services/v2/powerbi'

export default {
  props: ['id'],
  data: function () {
    return {
      isLoading: true
    }
  },
  watch: {
    $route (to, from) {
      this.fetchData()
    },
    '$i18n.locale' () {
      // localeSettings are only read at embed time, so re-embed on language change
      this.fetchData()
    }
  },
  mounted: async function () {
    await this.fetchData()
  },
  methods: {
    // Map the app's i18n locale to a PowerBI culture code
    pbiLocale () {
      const map = {
        en: 'en-US',
        fr: 'fr-FR',
        es: 'es-ES',
        pt: 'pt-PT',
        ru: 'ru-RU',
        zh: 'zh-CN',
        kr: 'ko-KR'
      }
      return map[this.$i18n.locale] || 'en-US'
    },
    async fetchData () {
      if (!this.$store.state.auth.user.group.powerBis[this.$route.params.id].id) {
        throw Error('Invalid role')
      }

      this.isLoading = true
      const models = pbi.models
      const res = await Powerbi.getPowerBiToken(this.$store.state.auth.user.group.powerBis[this.$route.params.id].id)
      const locale = this.pbiLocale()
      // Keep embedUrl clean: powerbi-client appends `language` + `formatLocale` itself from
      // localeSettings below (Embed.addLocaleToEmbedUrl). Hardcoding them here too produces
      // duplicate query params and makes Power BI ignore the culture entirely (no translation).
      const embedUrl = `https://app.powerbi.com/reportEmbed`
      const config = {
        type: 'report',
        permissions: models.Permissions.All,
        tokenType: models.TokenType.Embed,
        accessToken: res.token,
        embedUrl: embedUrl,
        id: this.$store.state.auth.user.group.powerBis[this.$route.params.id].id,
        settings: {
          localeSettings: {
            language: locale,
            formatLocale: locale
          }
        }
      }

      // Get a reference to the embedded report HTML element
      const reportContainer = this.$refs.pbiContainer
      // Clear any previously embedded report before re-embedding (e.g. on route/locale change)
      window.powerbi.reset(reportContainer)
      // Embed the report and display it within the div container.
      window.powerbi.embed(reportContainer, config)
      // DIAGNOSTIC: log the actual iframe URL the client built (remove once verified)
      // const iframe = reportContainer.querySelector('iframe')
      // console.log('[PBI] i18n locale =', this.$i18n.locale, '| pbiLocale =', locale)
      // console.log('[PBI] iframe src =', iframe && iframe.src)
      this.isLoading = false
    }
  }
}
</script>
<style scoped>
  .pbi-container {
    height: 85vh;
  }
</style>
